export default __webpack_public_path__ + "static/media/Axios.5ecfa25c.svg";